module.exports = {
  TestMasa: require("./build/contracts/TestMasa.json"),
  StkCorn: require("./build/contracts/StkCorn.json"),
  BaseRewardsVault: require("./build/contracts/BaseRewardsVault.json"),
  LoanFactory: require("./build/contracts/LoanFactory.json"),
  LoanRegistry: require("./build/contracts/LoanRegistry.json"),
  FundingPool: require("./build/contracts/FundingPool.json"),
  Ubeswap: require("./lib/ubeswap/index.js"),
};
